import { toast } from 'react-toastify';
import { Button } from '@material-ui/core';
import { Container, Draggable } from 'react-smooth-dnd';
import { useTranslation } from 'react-i18next';
import React, { useRef, useEffect, useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import { colors } from '../../../../Shared/utils';
import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';
import { getDiskHealthPercentageComputingRules, setDiskHealthPercentageComputingRules } from '../../../../Functions/columns'

import DiskHealthRule from './DiskHealthRule';

// import { updateColumns } from '../../../../Functions/user';
import { useAppContext } from '../../../../Context/App/Provider';

import './Columns.css';
import '../../../SweetAlert.css'


export default function EditDiskHealthRules({ groupId, setEditingDiskHealthPercentageComputingRules }) {
  const { t } = useTranslation();

  const [{ settings }] = useAppContext();
  const [errorInRules, setErrorInRules] = useState(true)
  const [loading, setLoading] = useState(false);
  const [rules, setRules] = useState([]);

  useEffect(() => {
    if (rules.length === 0) {
      setLoading(true);
      getDiskHealthPercentageComputingRules(groupId).then(res => {
        setLoading(false);

        if (!res.success) {
          let loadedRules = [
            { attributeId: "1", weight: "1", limit: "1" },
            { attributeId: "5", weight: "1", limit: "70" },
            { attributeId: "7", weight: "0.5", limit: "20" },
            { attributeId: "10", weight: "3", limit: "60" },
            { attributeId: "196", weight: "0.6", limit: "30" },
            { attributeId: "197", weight: "0.6", limit: "48" },
            { attributeId: "198", weight: "0.6", limit: "70" }
          ];
          setRules(loadedRules);
          return
        }

        let loadedRules = [];
        if (res.rules && res.rules.length === 1 && res.rules[0].Rules) {
          loadedRules = JSON.parse(res.rules[0].Rules);
        }
        else {
          loadedRules = [
            { attributeId: "1", weight: "1", limit: "1" },
            { attributeId: "5", weight: "1", limit: "70" },
            { attributeId: "7", weight: "0.5", limit: "20" },
            { attributeId: "10", weight: "3", limit: "60" },
            { attributeId: "196", weight: "0.6", limit: "30" },
            { attributeId: "197", weight: "0.6", limit: "48" },
            { attributeId: "198", weight: "0.6", limit: "70" }
          ];
        }
        // console.log("108 - setRules=", loadedRules);
        setRules(loadedRules);
      });
    }
  }, [t, rules]);


  const handleSaveRules = () => {
    setLoading(true);
    const jsonRules = JSON.stringify(rules);
    // console.log("127 - jsonRules=", rules, jsonRules);

    setDiskHealthPercentageComputingRules(groupId, jsonRules).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('reporting.columns.disk_health_percentage_rules.error')), { type: 'error' });
      }
      toast(decodeHTMLEntities(t('reporting.columns.disk_health_percentage_rules.success')), { type: 'success' });
      setEditingDiskHealthPercentageComputingRules(false)
    });
  };


  const handleCheckRules = (locRules) => {
    for (const line of locRules) {
      if (isNaN(line.weight) || isNaN(line.limit)) {
        // console.log("error  isNaN(line.weight)=", isNaN(line.weight));
        // console.log("error  isNaN(line.limit)=", isNaN(line.limit));
        setErrorInRules(true)
        return false;
      }

      // if (Number(line.weight) < 0.1 || Number(line.weight) > 10) {
      //   // console.log("error  Number(line.weight)=", Number(line.weight));
      //   setErrorInRules(true)
      //   return false;
      // }

      if (Number(line.limit) < 1 || Number(line.limit) > 100) {
        // console.log("error  Number(line.limit)=", Number(line.limit));
        setErrorInRules(true)
        return false;
      }
    }
    setErrorInRules(false)
    return true;
  }

  const handleAddRule = () => {
    const tmpLine = {
      attributeId: "",
      weight: "1",
      limit: "70"
    }
    let locRules = [...rules];
    locRules.push(tmpLine);

    handleCheckRules(locRules);
    setRules([...locRules]);
  };

  const handleChangeRule = (rule, type, value) => {
    let locRules = [...rules];
    locRules[rule.seq][type] = value;

    handleCheckRules(locRules);
    setRules([...locRules]);
  };

  const handleRemoveRule = (rule) => {
    if (rules.length > 1) {
      let locRules = [...rules];
      locRules.splice(rule.seq, 1);

      handleCheckRules(locRules);
      setRules([...locRules]);
    }
  };

  // console.log("113 - Rules=", rules);
  // console.log("117 - Rules=", JSON.stringify(rules, null, 3));
  // console.log("179 - loading=", loading);

  return (
    <Prompt animated>
      <form className="prompt__container animated"
        style={{
          maxWidth: '820px'
          //height: '90%' 
        }}
        // onSubmit={e => console.log("e=", e)}
      >
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('reporting.columns.disk_health_percentage_rules.rules')}</h1>
          </div>

          <hr />
          <div className="prompt__content">
            <div className="flexRow" >
              <div style={{ textAlign: 'center', width: '25%' }}>
                {t('reporting.columns.disk_health_percentage_rules.smart_attributes_id')}
              </div>
              <div style={{ textAlign: 'center', width: '35%' }}>
                {t('reporting.columns.disk_health_percentage_rules.weight')}
              </div>
              <div style={{ textAlign: 'center', width: '35%' }}>
                {t('reporting.columns.disk_health_percentage_rules.limit')}
              </div>
              <div style={{ textAlign: 'center', width: '5%' }}>
              </div>
            </div>

            {(rules.length > 0) && (
              <Container                
                lockAxis="x|y"
                onDrop={o => console.log("253...")}
                dragHandleSelector=".drag-handle"
                onDragStart={o => console.log("255")}
              >
                {rules.map((rule, key) => {
                  rule.seq = key;
                  return (
                    <DiskHealthRule
                      disabled={loading}
                      rule={rule}
                      rules={rules}
                      handleChangeRule={handleChangeRule}
                      handleRemoveRule={handleRemoveRule}
                    />
                  )
                })}
              </Container>
            )}


            {(loading) ? (
              <div className="loader">
                <BeatLoader color={colors.softthinks}></BeatLoader>
              </div>
            ) : (
              <Button
                className="button"
                disabled={loading}
                onClick={handleAddRule}
                style={{ backgroundColor: 'var(--button-bg)', margin: '0 auto' }}
                startIcon={<span className="material-icons-round">add_circle_outline</span>}
              >
                {t('reporting.columns.disk_health_percentage_rules.add_attribute')}
              </Button>
            )}

          </div>
        </PromptWrapper>

        <PromptActions>
          <Button
            className="btnSecondary"
            disabled={loading}
            onClick={() => setEditingDiskHealthPercentageComputingRules(false)}
          >
            {t('global.cancel')}
          </Button>

          <Button
            className="btnPrimary"
            disabled={loading || errorInRules}
            onClick={() => {
              handleSaveRules();
            }}
          >
            {t('global.confirm')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
